import { render, staticRenderFns } from "./AppraiseRepair.vue?vue&type=template&id=89d85432"
import script from "./AppraiseRepair.vue?vue&type=script&lang=js"
export * from "./AppraiseRepair.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports